import classnames from 'classnames/bind';
import moment from 'moment';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';

import { Communicators } from 'presentation/components/lib/communicators';
import overrideStyle from 'lib/overrideStyle';
import styles from 'presentation/components/styles/Message.css';
import { getFormats } from 'app/modules';
let cx = classnames.bind(styles);

class Timestamp extends React.Component {
  constructor(props) {
    super(props);

    const timestampPropTypes = {
      sender: PropTypes.string.isRequired,
      timeFormat: PropTypes.string.isRequired,
      timestamp: PropTypes.instanceOf(Date),
    };
    PropTypes.checkPropTypes(timestampPropTypes, props, 'prop', 'Timestamp');
  }

  render() {
    if (!this.props.timestamp) {
      return;
    }

    let classes = cx('message_timestamp', {
      message_timestamp_customer: this.props.sender === Communicators.CUSTOMER,
    });
    classes += ' message_timestamp';
    return <Wrapper className={classes}>{formatTimestamp(this.props.timestamp, this.props.timeFormat)}</Wrapper>;
  }
}

export function formatTimestamp(timestamp, format) {
  return moment(timestamp).format(format);
}

const mapStateToProps = (state, { sender, timestamp }) => {
  return {
    sender,
    timestamp,
    timeFormat: getFormats(state).time,
  };
};

export default connect(mapStateToProps)(Timestamp);

const Wrapper = overrideStyle('div')`
  font-family: ${p => p.theme.fontLibrary.primary};
`;
